module.exports = __webpack_public_path__ + "img/icon-csv.f2b8caae.svg";